const baseUrl =
  process.env.NODE_ENV === 'production'
    ? 'https://liangshu.idea888.com/api'
    : 'http://192.168.2.156:8848/api';
    // : 'http://192.168.137.119:8848/api';

export default baseUrl;
